import React from "react"

import { useTranslations } from "@cirrus/core/i18n/provider";
import { CompactDialog, SupportedFileType } from "@cirrus/ui-kit-ts"

import { ActionButtons } from "./ActionButtons"
import { Form } from "./Form"
import { Files } from "../../types/Files"

interface IProps {
  isOpened: boolean,
  files: Files,
  fileCount: number,
  maxAttachments: number,
  maxAttachmentSize: number,
  supportedFileTypes?: string[],
  supportedFileTypesLabel?: string,
  setFiles: (files: Files) => void,
  onSave: () => void,
  onRemove: (index: number) => void,
  onClose: () => void,
}

export const AttachmentDialog = ({
  isOpened,
  files,
  fileCount,
  maxAttachments,
  maxAttachmentSize,
  supportedFileTypes = Object.keys(SupportedFileType),
  supportedFileTypesLabel = "Word, Excel, Powerpoint, PDF",
  setFiles,
  onSave,
  onRemove,
  onClose,
}: IProps) => {
  const { i18n } = useTranslations()

  return <CompactDialog
    title={i18n("General:AttachFiles")}
    open={isOpened}
    actionButtons={<ActionButtons
      files={files}
      fileCount={fileCount}
      maxAttachments={maxAttachments}
      maxAttachmentSize={maxAttachmentSize}
      onSave={onSave}
      onClose={onClose}
    />}
    sx={{ width: "45rem" }}
    onClose={onClose}>

    <Form
      files={files}
      fileCount={fileCount}
      maxAttachments={maxAttachments}
      maxAttachmentSize={maxAttachmentSize}
      supportedFileTypes={supportedFileTypes}
      supportedFileTypesLabel={supportedFileTypesLabel}
      setFiles={setFiles}
      onRemove={onRemove}
    />

  </CompactDialog>
}
